import Loadable from 'react-loadable';
import React from 'react';
import SkeletonWithOrgs from '../primitives/skeleton-with-orgs';
import { Skeleton } from '../primitives';
import { fg } from '@atlaskit/platform-feature-flags';

export const loadAtlassianSwitcher = () =>
	import(
		/* webpackChunkName: "@ak-switcher-chunk-atlassian-switcher" */ './atlassian-switcher'
	).then((module) => module.default);

export const loadJiraSwitcher = () =>
	import(/* webpackChunkName: "@ak-switcher-chunk-jira-switcher" */ './jira-switcher').then(
		(module) => module.default,
	);

export const loadConfluenceSwitcher = () =>
	import(
		/* webpackChunkName: "@ak-switcher-chunk-confluence-switcher" */ './confluence-switcher'
	).then((module) => module.default);

export const loadGenericSwitcher = () =>
	import(/* webpackChunkName: "@ak-switcher-chunk-generic-switcher" */ './generic-switcher').then(
		(module) => module.default,
	);

export const AtlassianSwitcherLoader = Loadable({
	loader: loadAtlassianSwitcher,
	loading: () => (fg('app-switcher-skeleton-with-org-item') ? <SkeletonWithOrgs /> : <Skeleton />),
});

export const JiraSwitcherLoader = Loadable({
	loader: loadJiraSwitcher,
	loading: () => (fg('app-switcher-skeleton-with-org-item') ? <SkeletonWithOrgs /> : <Skeleton />),
});

export const ConfluenceSwitcherLoader = Loadable({
	loader: loadConfluenceSwitcher,
	loading: () => (fg('app-switcher-skeleton-with-org-item') ? <SkeletonWithOrgs /> : <Skeleton />),
});

export const GenericSwitcherLoader = Loadable({
	loader: loadGenericSwitcher,
	loading: () => (fg('app-switcher-skeleton-with-org-item') ? <SkeletonWithOrgs /> : <Skeleton />),
});
